export default {

	/**
	 * Create the legend group
	 * 
	 * @param {Object} options 
	 */
	createLegend(options) {
		let height = this.getHeight(options.colorSpans)
		let width = this.getWidth(options.colorSpans, options.analysis.legendTitle)

		var rect = new fabric.Rect({
			width: width,
			height: height,
			fill: 'white',
			stroke: 'black',
			strokeWidth: 1,
			lockRotation: true,
			rx: 3,
			ry: 3,
		});

		let titleText;
		if(options.analysis.legendTitle) {
			titleText = options.analysis.legendTitle
		} else {
			titleText = options.analysis.title
		}

		let title = this.addTitle(width / 2, titleText)
		let rows = this.addRows(options.colorSpans)

		let top = this.getTopPosition(options.colorSpans, options.pageHeight)

		if(options.bottom) {
			top = options.bottom - this.getHeight(options.colorSpans)
		}

		let settings
		if(options.templateSettings && Object.keys(options.templateSettings).length) {
			settings = options.templateSettings
		} else {
			settings = {
				left: options.left ? options.left : 20,
				top: top,
			}

			if(options.scaleX && options.scaleY) {
				settings.scaleX = options.scaleX
				settings.scaleY = options.scaleY
			}
			if(options.angle) {
				settings.angle = options.angle
			}
		}

		settings.type = 'legend'
		var group = new fabric.Group([rect, title, rows], settings);

		return group
	},


	/**
	 * Adds the legends title
	 * 
	 * @param {float} center 
	 * @param {String} title 
	 */
	addTitle(center, title) {
		return new fabric.Text(title, {
			originX: 'center',
			left: center,
			top: 5,
			fontSize: 17,
			fontFamily: 'Helvetica'
		});
	},

	/**
	 * Will add all the rows to the legend
	 * 
	 * @param {array} colorSpans
	 */
	addRows(colorSpans) {

		let currentY = 0

		let rows = []
		colorSpans.forEach((element, i) => {
			rows.push(this.addRow(currentY, element.Rgb, element.to, element.from, i === colorSpans.length - 1))
			currentY += 17
		})

		return new fabric.Group(rows, {
			top: 30,
			left: 10,
		})

	},

	/**
	 * Add a row to the legend containing the interval between two values
	 * 
	 * @param {float} y 
	 * @param {String} color 
	 * @param {float} to 
	 * @param {float} from 
	 */
	addRow(y, color, to, from, lastRow) {
		let rect = new fabric.Rect({
			width: 17,
			height: 13,
			top: y,
			fill: color,
			stroke: 'black',
			strokeWidth: 1,
			lockRotation: true,
		})

		let valueSpan = this.generateValueString(from, lastRow ? null : to)

		let text = new fabric.Text(valueSpan, {
			left: 30,
			top: y,
			fontSize: 13,
			fontFamily: 'Helvetica'
		});

		return new fabric.Group([rect, text])
	},

	/**
	 * Returns the height of the legend
	 * is calculated from the number of rows and the title
	 * @param {array} colorSpans The current colorSpans
	 */
	getHeight(colorSpans) {
		let rowsHeight = 17 * colorSpans.length

		return rowsHeight + 35
	},

	/**
	 * Returns the number of pixels from the top of the page
	 * to where the top of the legend should be placed
	 * 
	 * @param {array} colorSpans The current colorSpans
	 */
	getTopPosition(colorSpans, pageHeight) {
		let legendHeight = this.getHeight(colorSpans)
		let bottomPadding = 20

		return pageHeight - legendHeight - bottomPadding
	},

	/**
	 * Calculate the maximum width of all the intervals that will be printed in the legend
	 * 
	 * @param {array} colorSpans 
	 */
	getWidth(colorSpans, title) {
		let maxCharacters = 0

		let tmp = 0
		colorSpans.forEach(element => {
			tmp = this.generateValueString(element.from, element.to).length
			if(tmp > maxCharacters) {
				maxCharacters = tmp
			}
		})

		if(title && title.length > maxCharacters) {
			maxCharacters = title.length
		}

		return 40 + maxCharacters * 6.5 + 5
	},

	/**
	 * Helper function that will return the string from one analysis value to the next
	 * Eg. 6.5 - 6.8 or 7.8+
	 * 
	 * @param {String} to 
	 * @param {String} from 
	 */
	generateValueString(from, to) {
		return to ? from + " - " + to : from + " +"
	}

}